import React, { useState, useEffect } from 'react';
import './App.css';
import SVGSlide from './components/SVGSlide';
import LoginPage from './components/LoginPage';

const slides = [
  SVGSlide
];

function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if user was previously authenticated (optional - persists login)
  useEffect(() => {
    const authStatus = localStorage.getItem('revizr_authenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  // Detect if device is mobile
  useEffect(() => {
    const checkIsMobile = () => {
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      setIsMobile(isMobileDevice || isTouchDevice);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const handleLogin = (status) => {
    setIsAuthenticated(status);
    // Optional: persist login status
    localStorage.setItem('revizr_authenticated', 'true');
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'ArrowRight' || e.key === ' ') {
        setCurrentSlide(prev => (prev + 1) % slides.length);
      } else if (e.key === 'ArrowLeft') {
        setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
      } else if (e.key >= '1' && e.key <= '9') {
        const slideIndex = parseInt(e.key) - 1;
        if (slideIndex < slides.length) {
          setCurrentSlide(slideIndex);
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  const CurrentSlideComponent = slides[currentSlide];

  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <div className="app">
      <div className="slide-container">
        <CurrentSlideComponent />
      </div>
      <div className="slide-counter">
        {currentSlide + 1} / {slides.length}
      </div>
      <div className="navigation-hint">
        {isMobile ? (
          'Swipe left/right/up/down or use buttons to navigate'
        ) : (
          'Use arrow keys, spacebar, or F11 for fullscreen'
        )}
      </div>
    </div>
  );
}

export default App;